import { IMotivoCompra } from "../../../../Interfaces/Geral/GestaoDeCadastro/MotivoCompra/MotivoCompraInterfaces";
import {
    DeletarMotivoCompraService,
    InserirMotivoCompraService,
    ListarMotivoCompraService,
} from "../../../../Services/Geral/MotivoCompra/MotivoCompraServices";
import { Controller } from "../../../Controller";

export async function ListarMotivoCompraController() {
    return Controller(ListarMotivoCompraService());
}

export async function InserirMotivoCompraController(
    requestBody: IMotivoCompra
) {
    return Controller(InserirMotivoCompraService(requestBody));
}

export async function DeletarMotivoCompraController(ID_MOTIVO_COMPRA: number) {
    return Controller(DeletarMotivoCompraService(ID_MOTIVO_COMPRA));
}
